<template>
  <div class="meta-navi">
    <login-links
      v-if="loginLinks"
      :link-title="loginLinks.buttonTitle"
      :links="loginLinks.links"
    />

    <nav-link-list
      v-if="secondaryLinks"
      context="meta"
      :links="secondaryLinks"
      :view-type="isReduced ? 'icon' : 'both'"
    />
  </div>
</template>

<script>
import LoginLinks from './LoginLinks'
import NavLinkList from './NavLinkList'

export default {
  name: 'MetaNavi',
  components: { NavLinkList, LoginLinks },
  props: {
    isReduced: Boolean,
    loginLinks: {
      type: Object,
      default: () => {},
    },
    secondaryLinks: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="postcss">
.meta-navi {
  display: flex;
  align-items: center;
  gap: 0 var(--spacing-6);
  height: 20px;
}

@media (--lg) {
  .meta-navi {
    gap: 0 var(--spacing-6);
    flex: 1 100%;
    justify-content: flex-end;
  }
}
</style>
